export default {
  common: {
    login: 'Войти',
    logout: 'Выход',
    support: 'Поддержка',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
    and: 'и',
    guest: 'Гость',
    loading: 'Загрузка',
    play: 'Играть',
    install: 'Установить',
  },
  auth: {
    loading: '@:(common.loading)...',
  },
  support: {
    title: 'Нужна помощь?',
    description: `Если вы пользователь этой игры и у вас возникли проблемы,
      мы будем рады помочь вам и ответить на все вопросы`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption: `Помогите дворецкому Остину вернуть тепло и комфорт в его чудесный семейный особняк.`,
    description: `Помогите дворецкому Остину вернуть тепло
      и комфорт в его чудесный семейный особняк.
      Входите - приключения ждут прямо за дверью!`,
  },
  cookie: {
    message: 'На этом сайте используются файлы cookie',
    link: 'Подробнее',
    button: 'Принять',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes на вашем рабочем столе!
    Установите специальную веб-версию игры, и заходите в гости к Остину в два клика!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla is an authorized global distributor of Homescapes',
  },
  game: {
    notSupported: `Мобильные устройства не поддерживаются.
      Зайдите с компьютера, чтобы поиграть.`,
  },
};
